module.exports = __webpack_public_path__ + "img/success.644fed28.svg";